// Routes definition
const routes_web = {

    // Home
    home: "/",

    // App Pages
    pages_home: "/welcome/",
    pages_register: "/register/",

    // App Accounts
    accounts_home: "/app/",
    accounts_login: "/app/login/",
    accounts_initial: "/app/initial/",
    accounts_main: "/app/accounts/",
    accounts_usersettings: "/app/usersettings/",
    accounts_generalsettings: "/app/general-settings/",

    // Functional Apps
    core_main: "/app/core/",
    health_main: "/app/health/",
    travel_main: "/app/travel/",
    finance_main: "/app/finance/",
    planner_main: "/app/planner/",
    notepad_main: "/app/notepad/",
    identity_main: "/app/identity/",

    // ##### MEDIAS
    img_logo_qapp_512: '/static/img/logo_512.png',
    img_welcome_bg: '/static/img/welcome-bg.png',
    img_error_bg: '/static/img/error-bg.png',
    img_core_frame: '/static/img/core_frame.png',
    
    // Install Guide Images
    img_install_android_step1: '/static/pages-static/install-png/install_android_step1.png',
    img_install_android_step2: '/static/pages-static/install-png/install_android_step2.png',
    img_install_ios_step1: '/static/pages-static/install-png/install_ios_step1.png',
    img_install_ios_step2: '/static/pages-static/install-png/install_ios_step2.png',
  };
  
  export default routes_web;
